import { render } from "./PropertyPhotosModal.vue?vue&type=template&id=884ab1c0"
import script from "./PropertyPhotosModal.vue?vue&type=script&lang=js"
export * from "./PropertyPhotosModal.vue?vue&type=script&lang=js"

import "./PropertyPhotosModal.vue?vue&type=style&index=0&id=884ab1c0&lang=scss"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__